import styles from "./Sections.module.css";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../../contexts/auth.context";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

function Menu() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const edit = searchParams.get("edit");

  useContext(AuthContext);

  const _goCastores = () => {
    _go("Castores");
  };
  const _goLobatos = () => {
    _go("Lobatos");
  };
  const _goScouts = () => {
    _go("Scouts");
  };
  const _goEscultas = () => {
    _go("Escultas");
  };
  const _goRovers = () => {
    _go("Rovers");
  };
  const _goScouters = () => {
    _go("Scouters");
  };

  const _go = (section) => {
    navigate(`/listLearners/${section}${edit ? "?edit=true" : ""}`);
  };

  return (
    <div className={styles["sections-container"]}>
      <ScreenHeader title="Secciones" />
      <div className={styles["sections-menu"]}>
        <button className={`${styles.section} ${styles.castores}`} onClick={_goCastores}>
          Castores
        </button>
        <button className={`${styles.section} ${styles.lobatos}`} onClick={_goLobatos}>
          Lobatos
        </button>
        <button className={`${styles.section} ${styles.scouts}`} onClick={_goScouts}>
          Scouts
        </button>
        <button className={`${styles.section} ${styles.escultas}`} onClick={_goEscultas}>
          Escultas
        </button>
        <button className={`${styles.section} ${styles.rovers}`} onClick={_goRovers}>
          Rovers
        </button>
        <button className={`${styles.section} ${styles.scouters}`} onClick={_goScouters}>
          Scouters
        </button>
      </div>
    </div>
  );
}

export default Menu;
